import React from "react"
import PropTypes from "prop-types"
import { sizes } from "./utils"

const InstrumentIcon = ({ color = "#FFF", size = "large" }) => (
  <svg
    viewBox="0 0 60 60"
    width={sizes[size].width}
    height={sizes[size].height}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill={color} fillRule="nonzero">
      <path d="M32.893 10.053a.79.79 0 01.092 1.573l-.092.006H3.947a2.369 2.369 0 00-2.364 2.229L1.579 14v41.053c0 1.261.986 2.292 2.23 2.364l.138.004H45a2.369 2.369 0 002.364-2.23l.004-.138V26.94a.79.79 0 011.574-.092l.005.092v28.113a3.947 3.947 0 01-3.776 3.943L45 59H3.947a3.947 3.947 0 01-3.943-3.776L0 55.053V14a3.947 3.947 0 013.776-3.944l.171-.003h28.946zM50.328 9.805a16.637 16.637 0 00-11.841-4.902.798.798 0 000 1.594c8.368-.003 15.152 6.781 15.149 15.15a.798.798 0 001.595 0 16.637 16.637 0 00-4.903-11.842z" />
      <path d="M43.562 16.571a7.163 7.163 0 00-5.072-2.106.798.798 0 00-.006 1.595 5.597 5.597 0 015.59 5.589.797.797 0 101.594-.005 7.163 7.163 0 00-2.106-5.073z" />
      <path d="M50.118 18.901a11.892 11.892 0 00-8.886-8.886 12.051 12.051 0 00-2.743-.33.797.797 0 100 1.595c.734 0 1.466.08 2.185.235a10.335 10.335 0 017.943 7.944c.155.718.233 1.452.234 2.187a.798.798 0 001.594 0 12.05 12.05 0 00-.327-2.745zM39.615 20.519a1.595 1.595 0 10-2.256 2.255 1.595 1.595 0 002.256-2.255zM18.947 17.158V29H7.105V17.158h11.842zm-1.579 1.579H8.684v8.684h8.684v-8.684zM37.105 43.21v10.264h-1.579V43.21zM40.263 43.21v10.264h-1.579V43.21zM43.421 43.21v10.264h-1.579V43.21z" />
    </g>
  </svg>
)

InstrumentIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
}

export default InstrumentIcon
